import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Logo from "../components/Logo";
import { LOGO_AUTH_SECONDARY } from "../config/logoSizes";
const ForgotPassword = () => {
  useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Please enter your email.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await axios.post("/api/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };
  return <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-card">
        <div className="auth-logo-area" onClick={() => navigate("/chat")} style={{ cursor: "pointer" }}>
          <Logo variant="full" size={LOGO_AUTH_SECONDARY} className="auth-logo-img" />
        </div>
        {!sent ? <>
            <p className="auth-title">Forgot Password?</p>
            <p style={{ textAlign: "center", fontSize: 13, color: "var(--text-2)", marginBottom: 18, lineHeight: 1.6 }}>
              Enter your email and we'll send you a reset link.
            </p>
            {error && <div className="form-alert error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email Address</label>
                <input
    className="form-input"
    type="email"
    placeholder="you@example.com"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    autoFocus
  />
              </div>
              <button className="btn-primary" type="submit" disabled={loading}>
                {loading ? <><div className="spinner" /> Sending...</> : "Send Reset Link"}
              </button>
            </form>
          </> : <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 52, marginBottom: 14 }}>📧</div>
            <h3 style={{ fontFamily: "Outfit,sans-serif", fontSize: 18, fontWeight: 700, color: "var(--text-1)", marginBottom: 10 }}>Check your email</h3>
            <p style={{ fontSize: 13, color: "var(--text-2)", lineHeight: 1.7, marginBottom: 24 }}>
              If <strong style={{ color: "var(--accent)" }}>{email}</strong> is registered, you'll receive a reset link shortly. Check your spam folder too.
            </p>
          </div>}
        <div className="auth-foot">
          <Link to="/signin">← Back to Sign In</Link>
        </div>
      </div>
    </div>;
};
var stdin_default = ForgotPassword;
export {
  stdin_default as default
};
